import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { SIZE } from '../constants/common.js';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledIconButton = /*#__PURE__*/_styled(IconButton, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1bh8t045"
})(_ref => {
  let {
    theme,
    color,
    hoverColorIconButton,
    fontSize,
    padding
  } = _ref;
  return {
    padding,
    '& svg': {
      color,
      fontSize,
      '& path': {
        fill: "".concat(color, " !important")
      }
    },
    '& i': {
      color,
      fontSize
    },
    '&.Mui-disabled': {
      pointerEvents: 'auto',
      '& svg': {
        color: theme.customColors.grey[300],
        '& path': {
          fill: "".concat(theme.customColors.grey[300], " !important")
        }
      },
      '& i': {
        color: theme.customColors.grey[300]
      },
      '&:hover': {
        '& *': {
          color: theme.customColors.grey[300],
          '& path': {
            fill: "".concat(theme.customColors.grey[300], " !important")
          }
        }
      }
    },
    '&:hover': {
      backgroundColor: 'transparent',
      '& svg': {
        color: hoverColorIconButton,
        backgroundColor: 'transparent',
        '& path': {
          fill: "".concat(hoverColorIconButton, " !important")
        }
      },
      '& i': {
        color: hoverColorIconButton,
        backgroundColor: 'transparent'
      }
    }
  };
}, "");
const StyledIconButtonTooltipContainer = /*#__PURE__*/_styled('span', {
  shouldForwardProp: isStyledPropsValid,
  target: "e1bh8t044"
})(_ref2 => {
  return {
    display: 'inline-flex'
  };
}, "");
const StyledButton = /*#__PURE__*/_styled(Button, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1bh8t043"
})(_ref3 => {
  let {
    theme,
    variant,
    disabled,
    size,
    divide,
    sx
  } = _ref3;
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    borderRadius: theme.borderRadius.radiusNormal,
    padding: '7.5px 24px',
    fontSize: '14px',
    lineHeight: 1.5,
    textTransform: 'initial'
  }, variant !== 'text' && {
    boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.1)'
    }
  }), size === SIZE.XL && {
    padding: '8.5px 24px',
    height: '36px',
    minWidth: '120px'
  }), size === SIZE.LARGE && {
    padding: '6.5px 24px',
    minWidth: '120px',
    height: '36px'
  }), size === SIZE.MEDIUM && {
    padding: '4.5px 24px',
    minWidth: '80px',
    height: '32px'
  }), size === SIZE.SMALL && {
    padding: '4px 16px',
    fontSize: '12px',
    height: '28px'
  }), divide && {
    paddingLeft: '16px',
    paddingRight: '16px'
  }), size === SIZE.XS && {
    padding: '2px 8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    fontSize: '12px',
    height: '24px'
  }), size === SIZE.XSS && {
    padding: '0px 4px',
    fontSize: '12px',
    height: '16px'
  }), variant === 'text' && disabled && {
    color: theme.customColors.grey[500],
    background: 'none'
  }), variant === 'shadow' && {
    color: theme.customColors.grey[700],
    background: 'none',
    boxShadow: "1px 1px 0px 0px rgba(0,0,0,0.1)",
    border: '1px solid transparent',
    '&:hover': {
      border: "1px solid ".concat(theme.customColors.grey[300]),
      background: 'none',
      boxShadow: "1px 1px 0px 0px rgba(0,0,0,0.1)"
    },
    '&:active': {
      border: "1px solid ".concat(theme.customColors.grey[300])
    }
  }), {}, {
    '&.Mui-disabled': _objectSpread2(_objectSpread2(_objectSpread2({
      cursor: 'not-allowed',
      backgroundColor: theme.customColors.grey[500],
      color: theme.customColors.white,
      // boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.1)',

      '& .MuiCircularProgress-svg': {
        color: theme.customColors.white
      }
    }, variant === 'text' && {
      color: theme.customColors.grey[500],
      backgroundColor: 'none'
    }), variant === 'outlined' && {
      backgroundColor: 'unset',
      color: theme.customColors.grey[500],
      border: "1px solid ".concat(theme.customColors.grey[500]),
      '& .MuiCircularProgress-svg': {
        color: theme.customColors.grey[500]
      }
    }), variant === 'shadow' && {
      backgroundColor: 'unset',
      boxShadow: 0,
      color: theme.customColors.grey[500]
    })
  }, sx), {}, {
    '& .MuiButton-startIcon': {
      margin: '0 4px 0 0'
    },
    '& .MuiButton-endIcon': {
      margin: '0 0 0 4px'
    }
  }, divide && {
    '& .MuiButton-endIcon': {
      margin: '0 0 0 24px'
    }
  }), divide && size === SIZE.XS && {
    '& .MuiButton-endIcon': {
      margin: '0 0 0 16px'
    }
  }), {}, {
    '& .MuiButton-startIcon ,& .MuiButton-endIcon': {
      '& svg': {
        width: '16px',
        height: '16px'
      }
    }
  });
}, "");
const StyledLoadingImg = /*#__PURE__*/_styled('img', {
  shouldForwardProp: isStyledPropsValid,
  target: "e1bh8t042"
})(_ref4 => {
  return {
    width: '20px'
  };
}, "");
const StyledButtonCountdown = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1bh8t041"
})(_ref5 => {
  return {
    marginLeft: '5px'
  };
}, "");
const StyledAddButton = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1bh8t040"
})(_ref6 => {
  let {
    theme,
    color,
    borderColor
  } = _ref6;
  return {
    width: '100%',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: "1px dashed ".concat(borderColor),
    paddingLeft: '12px',
    paddingRight: '12px',
    borderRadius: '3px',
    height: '40px',
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    '& .plus': {
      marginRight: '15px',
      fontWeight: 900,
      display: 'flex'
    }
  };
}, "");
export { StyledAddButton, StyledButton, StyledButtonCountdown, StyledIconButton, StyledIconButtonTooltipContainer, StyledLoadingImg };